// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YJSo","content":"styles_content__h99k_","tableWrap":"styles_tableWrap__v77NC"};